import { useState } from 'react'

import Button from '@/components/Button'
import BillingInfoModal from '@/pages/app/Home/components/BillingInfoModal/BillingInfoModal'
import { PaymentSchedule, PlanType } from '@/types'

interface AddBillingInfoButtonProps {
  title?: string
  type?: 'dark' | 'light' | 'link'
  width?: number
  className?: string
  isLoading?: boolean
  isDisabled?: boolean
  defaultSchedule?: PaymentSchedule
  planType?: PlanType
}

/**
 * Reusable button that opens the BillingInfoModal when clicked.
 * Manages its own modal state internally.
 *
 * Usage:
 * ```tsx
 * <AddBillingInfoButton
 *   title="Add billing info"
 *   type="dark"
 *   defaultSchedule={PaymentSchedule.Annual}
 *   planType={PlanType.Pro}
 * />
 * ```
 */
export const AddBillingInfoButton = ({
  title = 'Add billing info',
  type = 'dark',
  width,
  className,
  isLoading = false,
  isDisabled = false,
  defaultSchedule,
  planType,
}: AddBillingInfoButtonProps) => {
  const [isBillingModalOpen, setIsBillingModalOpen] = useState(false)

  return (
    <>
      <Button
        title={title}
        onClick={() => setIsBillingModalOpen(true)}
        type={type}
        width={width}
        className={className}
        isLoading={isLoading}
        isDisabled={isDisabled}
      />
      <BillingInfoModal
        isOpen={isBillingModalOpen}
        onClose={() => setIsBillingModalOpen(false)}
        defaultSchedule={defaultSchedule}
        planType={planType}
      />
    </>
  )
}
